import { getSubdomain, fetchWithAuth } from "../helpers";
import { API_PASSWORD } from "../config";



export async function addFavoriteProducts(favorites = []) {
  const subdomain = getSubdomain();
  const url = `https://${subdomain}.restocash.app/api/add/favorite/products?api_password=${API_PASSWORD}`;

  console.log("Adding favorite products payload:", favorites);

  const res = await fetchWithAuth(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ favorites }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || "فشل في إضافة المنتجات المفضلة");
  return data;
}

export async function removeFavoriteProducts(favorites = []) {
  const subdomain = getSubdomain();
  const url = `https://${subdomain}.restocash.app/api/remove/favorite/products?api_password=${API_PASSWORD}`;

  console.log("Removing favorite products payload:", favorites);

  const res = await fetchWithAuth(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ favorites }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || "فشل في إزالة المنتجات من المفضلة");
  return data;
}


 export const getFavoriteProducts = async () => {
    const subdomain = getSubdomain();
    const branchId = localStorage.getItem("branch_id");

    if (!branchId) {
      throw new Error("❌ لا يوجد branch_id في localStorage");
    }

    const url = `https://${subdomain}.restocash.app/api/favorite/products/${branchId}`;

    try {
      const response = await fetchWithAuth(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        console.error("❌ فشل في جلب المفضلة:", data);
        throw new Error(data?.message || "فشل في جلب المفضلة");
      }

      console.log("✅ المفضلة:", data.data);
      return data.data;
    } catch (error) {
      console.error("❌ خطأ أثناء جلب المفضلة:", error);
      throw error;
    }
  };